// extracted by mini-css-extract-plugin
export default {"wrapper":"e9","container":"f9","box":"g9","title":"h9","rdwrap":"i9","rditem":"j9","rdimage":"k9","name":"l9","heading":"m9","text":"n9","guarantee":"o9","chatbox":"p9"};
    if(module.hot) {
      // 1713969939323
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  